import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import media from '../../utils/mediaQueries';

import Btn from '../buttons/Btn';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999999999;
`;

const Modal = styled.div`
  border-radius: 12px;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.02),
    0 2px 4px 0 rgba(155, 132, 135, 0.06), 0 4px 12px 0 rgba(119, 94, 98, 0.05);
  background-color: #ffffff;
  max-width: 500px;
  padding: 20px 24px 24px;
  ${media.mobile`
    width: 100%;
    margin: 10px;
  `}
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: #354354;
  margin-bottom: 16px;
`;

const Content = styled.section`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: #354354;
  margin-bottom: 16px;
`;

const BottomBar = styled.div`
  display: flex;
  & > button:first-child {
    margin-right: 24px;
  }
`;

class NonpremiumSchool extends Component {
  render() {
    const {
      title, texts, onDismiss, onConfirm,
    } = this.props;

    return (
      <Overlay>
        <Modal>
          <Title>{title}</Title>
          <Content>
            {map(JSON.parse(texts), (text) => (
              <p key={text}>{text}</p>
            ))}
          </Content>
          <BottomBar>
            <Btn
              type="button"
              outlined
              text="J'ai compris"
              onClick={onDismiss}
            />
            <Btn type="button" text="Devenir partenaire" onClick={onConfirm} />
          </BottomBar>
        </Modal>
      </Overlay>
    );
  }
}

NonpremiumSchool.propTypes = {
  title: PropTypes.string,
  texts: PropTypes.array,
  onDismiss: PropTypes.func,
  onConfirm: PropTypes.func,
};

NonpremiumSchool.defaultProps = {
  title: '',
  texts: [],
  onDismiss: () => {},
  onConfirm: () => {},
};

export default NonpremiumSchool;
